import { clientApi } from '../../configuration';
import { getPermissionListHook } from '../../utils';

const useStudentCredentialPermissions = getPermissionListHook({
  entityName: 'student-credential-permissions',
  apiResponseRootKey: 'studentCredentials',
  fetch: ({ userId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).studentCredentialPermissions.find(),
});

export default useStudentCredentialPermissions;
